module.exports = __webpack_public_path__ + "static/media/bear_girl_thumbsUpWinking.69e53c26.png";